import type { SimpleBoard } from "../levelgenerator/simpleBoard";
import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LevelChangerThing } from "./levelChangerThing";

export class Upstairs extends LevelChangerThing {
	static key = "Upstairs";
	constructor(xy: XY, destinationLevel: number) {
		super(xy, destinationLevel);
	}

	static initOnBoard(xy: XY, board: SimpleBoard, props?: Record<string, unknown>): PhysicalThing[] {
		const stairs = new Upstairs(xy, (props?.destination as number) ?? 0);
		board.putThing(stairs);
		return [stairs];
	}

	static deserialize(data: any): Upstairs {
		const u = new Upstairs(deserializeXY(data.xy), data.destinationLevel);
		u.visualId = data.visualId;
		return u;
	}
}
